module.exports = new __parcel__URL__("google_login_button.79722709.png").toString();